import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingContactsContainerLoadable } from 'shared/components/contacts_aside';
import { NewbuildingOnlineStatusContainer } from 'shared/containers/NewbuildingOnlineStatusContainer';
import { isNewbuildingFromDeveloperSelector } from 'shared/selectors';
import { selectShouldRenderContacts } from 'shared/selectors/contacts/selectShouldRenderContacts';
import { isPrintVersionPhoneVisibilitySelector } from 'shared/selectors/print';

import { MessageButtonContainer } from '../MessageButtonContainer';
import { PhonesContainer } from '../PhonesContainer';

export const NewbuildingPageAsideContactsContainer = () => {
  const shouldRenderContactButtons = useSelector(selectShouldRenderContacts);
  const isNewbuildingFromDeveloper = useSelector(isNewbuildingFromDeveloperSelector);
  const isPrintVersion = useSelector(isPrintVersionPhoneVisibilitySelector);
  const sendMessageButtonTitle = isNewbuildingFromDeveloper ? 'Написать застройщику' : 'Написать';

  return (
    <>
      {!isPrintVersion && (
        <NewbuildingContactsContainerLoadable contactsButton={<PhonesContainer />} callbackPlaceType="floating_block" />
      )}
      {shouldRenderContactButtons && <MessageButtonContainer buttonTitle={sendMessageButtonTitle} />}
      {isNewbuildingFromDeveloper && <NewbuildingOnlineStatusContainer />}
    </>
  );
};
